import { AnalyticsData } from './analytics.model';
import { AccessType } from '../auth/access-type.enum';

export class DocumentAnalyticsData extends AnalyticsData {

    constructor(docData : any,url:string) {
        super();
        this.PageType='documentViewer';
        this.event='viewContent';
        this.uri=url;
        this.Service=docData.serviceName;
        this.Region=docData.regionCode;
        this.DocumentName=docData.title;
        this.DocumentUniqueNumber=docData.uniqueNumber;
        this.DocumentInstanceId=docData.documentInstanceid;
        this.DocumentType=docData.documentType.name;
        this.Author=docData.creator;
        this.nonAuthorisedAccess=docData.demo && docData.accessType !== AccessType.FULL_ACCESS;
    }
}